import { Card, Col, Row, Spinner } from "reactstrap";
import React from "react";
import { useTranslation } from "react-i18next";
import { ToCustomDecimal } from "../../AppSystem/Helpers/ToCustomDecimal";
import { InfoPageMessage } from "../../Common/Components/Button/InfoPageMessage";

export function CardDigitalAccount({ data, label = null, displayValue = null }) {
    const { t } = useTranslation();

    return (
        <>
            <Card className='py-3 px-4'>
                {data !== null && data.id !== '' && data !== '' ? (
                    <>
                        <Row>
                            <Col xs='auto' className="fs-5 questrial-regular text-grey-custom pb-2">
                                <span className="fw-bold">
                                    {data.orgName ?? (label !== null && label.includes("searchCriteria")
                                        ? t('digitalAccount.totalBalanceSearch')
                                        : t("digitalAccount.totalBalance"))}
                                </span>
                                {data.orgType && <span className="ms-2">({data.orgType})</span>}
                            </Col>
                            <InfoPageMessage message='Reserverat belopp avser inlämnade och godkända ersättningsbegäran som ännu inte betalats ut'/>
                        </Row>
                        <Col lg={12} className="font-Space-Grotesk">
                            {displayValue === null || displayValue === "true" ? (
                                <>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', gap: '8px' }}>
                                        <span className="text-muted" style={{ fontSize: 'clamp(13px, 2.5vw, 17px)', whiteSpace: 'nowrap' }}>
                                            {t('digitalAccount.saldo')}
                                        </span>
                                        <span className={`fw-bold ${data.balance >= 0 ? 'text-green' : 'text-red'}`} style={{ fontSize: 'clamp(13px, 2.5vw, 17px)', whiteSpace: 'nowrap' }}>
                                            {data.balance ? ToCustomDecimal(data.balance) : 0} kr
                                        </span>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', gap: '8px' }}>
                                        <span className="text-muted" style={{ fontSize: 'clamp(13px, 2.5vw, 17px)', whiteSpace: 'nowrap' }}>
                                            {t('digitalAccount.reservedAmount')}
                                        </span>
                                        <span className="fw-bold text-red" style={{ fontSize: 'clamp(13px, 2.5vw, 17px)', whiteSpace: 'nowrap' }}>
                                            {data.reservedBalance ? ToCustomDecimal(-Math.abs(data.reservedBalance)) : 0} kr
                                        </span>
                                    </div>

                                    <hr />

                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', gap: '8px' }}>
                                        <span className="text-muted" style={{ fontSize: 'clamp(13px, 2.5vw, 17px)', whiteSpace: 'nowrap' }}>
                                            {t('digitalAccount.availableAmount')}
                                        </span>
                                        <span className={`fw-bold ${data.availableBalance >= 0 ? 'text-green' : 'text-red'}`} style={{ fontSize: 'clamp(13px, 2.5vw, 17px)', whiteSpace: 'nowrap' }}>
                                            {data.availableBalance ? ToCustomDecimal(data.availableBalance) : 0} kr
                                        </span>
                                    </div>
                                </>
                            ) : (
                                displayValue === "loading" && <Spinner color='success' style={{ width: '2.65rem', height: '2.65rem' }} />
                            )}
                        </Col>
                    </>
                ) : null}
            </Card>
        </>
    );
}